module.exports = __webpack_public_path__ + "assets/img/10.6f5a2be2.png";